import React, { useEffect } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import DashboardLayout from '../../components/Layout/DashboardLayout'
import Sidebar from '../../components/Sidebar/Sidebar'
import HospitalSelector from '../../components/Header/HospitalSelector'
import HuddleObservationOverview from './HuddleObservationOverview'
import HuddleBoardPreferences from './HuddleBoardPreferences'
import HuddleBoardTeam from './HuddleBoardTeam'
import HuddleBoardPlan from './HuddleBoardPlan'
import HuddlePerformanceByRole from './HuddlePerformanceByRole'
import HuddleNextHuddle from './HuddleNextHuddle'
import HuddleObservationComments from './HuddleObservationComments'
import HuddleFeedback from './HuddleFeedback'
import ClinicalPracticeObservations from './ClinicalPracticeObservations'

const RedirectWithParams: React.FC<{ to: string }> = ({ to }) => {
    const location = useLocation()
    return <Navigate to={`${to}${location.search}`} replace />
}

const HUDDLE_SIDEBAR_LINKS = [
    { label: 'Huddle Observation – Overview', path: '/hdl/observation-overview/' },
    {
        label: 'Discussion & Board Use',
        path: '',
        submenu: [
            { label: 'Team', path: '/hdl/team/' },
            { label: 'Preferences', path: '/hdl/preferences/' },
            { label: 'Plan', path: '/hdl/plan/' },
            { label: 'Next Huddle', path: '/hdl/next/' },
            { label: 'Huddle Performance By Role', path: '/hdl/performance-by-role/' },
        ],
    },
    {
        label: 'OBSERVATIONS & COMMENTS',
        path: '',
        submenu: [
            { label: 'Huddle Observation Comments', path: '/hdl/observation-comments/' },
            { label: 'Clinical Practice Observations', path: '/hdl/clinical-practice/' },
            { label: 'FEEDBACK', path: '/hdl/feedback/' },
        ],
    },
]

const HUDDLE_EXPORT_PAGES = [
    { url: '/hdl/observation-overview/', title: 'Huddle Observation – Overview' },
    { url: '/hdl/team/', title: 'Discussion & Board Use: Team' },
    { url: '/hdl/preferences/', title: 'Discussion & Board Use: Preferences' },
    { url: '/hdl/plan/', title: 'Discussion & Board Use: Plan' },
    { url: '/hdl/next/', title: 'Next Huddle' },
    { url: '/hdl/performance-by-role/', title: 'Huddle Performance By Role' },
    { url: '/hdl/observation-comments/', title: 'Huddle Observation Comments' },
    { url: '/hdl/clinical-practice/', title: 'Clinical Practice Observations' },
    { url: '/hdl/feedback/', title: 'Feedback' },
]

const HuddleIndex: React.FC = () => {
    useEffect(() => {
        const fontLinkId = 'huddle-poppins-font-link'
        const styleId = 'huddle-font-scope-style'

        let fontLink = document.getElementById(fontLinkId) as HTMLLinkElement | null
        if (!fontLink) {
            fontLink = document.createElement('link')
            fontLink.id = fontLinkId
            fontLink.rel = 'stylesheet'
            fontLink.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap'
            document.head.appendChild(fontLink)
        }

        let styleEl = document.getElementById(styleId) as HTMLStyleElement | null
        if (!styleEl) {
            styleEl = document.createElement('style')
            styleEl.id = styleId
            styleEl.textContent = `
.huddle-scope {
  font-family: "Poppins", "Segoe UI", sans-serif;
  width: 100%;
  min-height: 100vh;
}
.huddle-scope button,
.huddle-scope input,
.huddle-scope select,
.huddle-scope textarea {
  font-family: inherit;
}
.huddle-scope .sidebar .tab,
.huddle-scope .sidebar .toggle-submenu {
  font-family: "Poppins", "Segoe UI", sans-serif !important;
}
.huddle-scope div,
.huddle-scope span,
.huddle-scope p,
.huddle-scope h1,
.huddle-scope h2,
.huddle-scope h3,
.huddle-scope h4 {
  font-family: "Poppins", "Segoe UI", sans-serif !important;
}
            `.trim()
            document.head.appendChild(styleEl)
        }

        return () => {
            const s = document.getElementById(styleId)
            if (s) s.remove()
            const l = document.getElementById(fontLinkId)
            if (l) l.remove()
        }
    }, [])

    const sidebar = (
        <Sidebar
            logo="/logo1.webp"
            links={HUDDLE_SIDEBAR_LINKS}
            exportPages={HUDDLE_EXPORT_PAGES}
            exportTitle="Huddle Dashboard"
        />
    )

    const header = <HospitalSelector />

    return (
        <div className="huddle-scope">
            <DashboardLayout sidebar={sidebar} header={header}>
                <Routes>
                    <Route path="/" element={<RedirectWithParams to="/hdl/observation-overview/" />} />
                    <Route path="/observation-overview/" element={<HuddleObservationOverview />} />
                    <Route path="/team/" element={<HuddleBoardTeam />} />
                    <Route path="/preferences/" element={<HuddleBoardPreferences />} />
                    <Route path="/plan/" element={<HuddleBoardPlan />} />
                    <Route path="/next/" element={<HuddleNextHuddle />} />
                    <Route path="/performance-by-role/" element={<HuddlePerformanceByRole />} />
                    <Route path="/observation-comments/" element={<HuddleObservationComments />} />
                    <Route path="/clinical-practice/" element={<ClinicalPracticeObservations />} />
                    <Route path="/feedback/" element={<HuddleFeedback />} />
                    <Route path="*" element={<RedirectWithParams to="/hdl/observation-overview/" />} />
                </Routes>
            </DashboardLayout>
        </div>
    )
}

export default HuddleIndex
